import * as React from 'react'
import { InputWrapper } from '@/components/inputs/base/input-wrapper'
import { BaseInputProps } from '@/components/inputs/base/types'
import { Input, InputProps } from '~/@/components/ui/input-v2'

export type ShortTextInputProps = InputProps & BaseInputProps

export const ShortTextInput = React.forwardRef<HTMLInputElement, ShortTextInputProps>(
  (
    {
      className,
      disabled,
      placeholder,
      isBorderless,
      wrapperClassName,
      errorText,
      helperText,
      label,
      required,
      showDirtyIndicator,
      tooltip,
      startAdornment,
      startAdornmentSpacing,
      endAdornment,
      endAdornmentSpacing,
      ...props
    },
    ref,
  ) => {
    return (
      <InputWrapper
        wrapperClassName={wrapperClassName}
        errorText={errorText}
        helperText={helperText}
        label={label}
        required={required}
        showDirtyIndicator={showDirtyIndicator}
        tooltip={tooltip}
      >
        <Input
          ref={ref}
          className={className}
          disabled={disabled}
          placeholder={placeholder}
          isBorderless={isBorderless}
          startAdornment={startAdornment}
          startAdornmentSpacing={startAdornmentSpacing}
          endAdornment={endAdornment}
          endAdornmentSpacing={endAdornmentSpacing}
          {...props}
        />
      </InputWrapper>
    )
  },
)

ShortTextInput.displayName = 'ShortTextInput'
